import { fg } from '@atlassian/jira-feature-gating';

const JiraAiDeeplinkFastFollowsRelayProvider = {
	get(): boolean {
		return fg('jira_ai_deeplink_fast_follows');
	},
};

export default JiraAiDeeplinkFastFollowsRelayProvider;
